/* istanbul ignore file */
import { UpdatePageLayout } from 'framework/ui/layout';
import { UpdateForm } from 'framework/form';
import { useAssignmentService } from 'domain/shared/assignment';
import EmployeeAssignmentForm from '../EmployeeAssignmentForm';
import {
  useEmployeeAssignmentId,
  useEmployeeAssignmentUrl,
} from 'domain/people/employee/assignments/assignmentRouting';

const UpdateEmployeeAssignment = () => {
  const { update, getValidationSchema, getAssignmentById } = useAssignmentService();
  const { getListUrl } = useEmployeeAssignmentUrl();
  const id = useEmployeeAssignmentId();

  return (
    <UpdateForm
      submitFormFunc={update}
      getDataFunc={getAssignmentById}
      entityId={id}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Assignment has been successfully saved.',
      }}
    >
      <UpdatePageLayout title="Edit: Assignment" titleVariant="h4">
        <EmployeeAssignmentForm />
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateEmployeeAssignment;
